import { of, throwError } from 'rxjs';
import { AuthService } from '@sc/pas-common';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
var GlobalHeaderInterceptor = /** @class */ (function () {
    function GlobalHeaderInterceptor(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    GlobalHeaderInterceptor.prototype.intercept = function (request, next) {
        var _this = this;
        var currentSession = this.authService.currentSessionValue;
        var authURL = /\/auth\//gi;
        var headerParams = {
            'Ocp-Apim-Trace': 'true'
        };
        if (currentSession && currentSession.jwt && request.url.search(authURL) === -1) {
            headerParams['Authorization'] = "Bearer " + currentSession.jwt;
            headerParams['userName'] = currentSession.username;
            headerParams['x-id'] = currentSession.username;
            if (currentSession.branchOffice) {
                headerParams['x-branchOffice'] = currentSession.branchOffice.toString();
            }
            request = request.clone({
                setHeaders: headerParams
            });
        }
        return next.handle(request).pipe(catchError(function (error) { return _this.handleAuthError(error); }));
    };
    GlobalHeaderInterceptor.prototype.handleAuthError = function (error) {
        if (error.status === 401 && !this.router.url.startsWith('/login')) {
            localStorage.clear();
            this.router.navigateByUrl("/login");
            return of(error.message);
        }
        return throwError(error);
    };
    return GlobalHeaderInterceptor;
}());
export { GlobalHeaderInterceptor };
